import { render } from "./ReviewApplicantType.vue?vue&type=template&id=7c605c04&scoped=true"
import script from "./ReviewApplicantType.vue?vue&type=script&lang=js"
export * from "./ReviewApplicantType.vue?vue&type=script&lang=js"

import "./ReviewApplicantType.vue?vue&type=style&index=0&id=7c605c04&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c605c04"]])

export default __exports__